import {useAtom} from 'jotai';
import {roleAtom} from '@lib/atoms';
import type {UserRole} from '@api/auth/types';

/** Возвращает текущую роль пользователя. */
export const useRole = (): UserRole => {
  const [role] = useAtom(roleAtom);
  return role;
};
